import React from "react"
import styled from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image"

import { ElementProps, elementCss } from "components/shared/base"

export type ImageProps = ElementProps

const Image = styled(({
  alt,
  image,
  ...props

}): React.ReactElement | null => {

  if (!alt || !image) return null

  return (
    <GatsbyImage
      alt={alt}
      image={image}
      {...props} />
  )
})<ImageProps>`
  ${elementCss}
`

Image.defaultProps = {
  fontSize: "12px",
  width: "100%",
}

export default Image
